const MOBILE_BREAKPOINT = 768

export function initVideoSource() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    for (const section of document.querySelectorAll('.video-source:not([data-video-initialized])')) {
        const videoUrl = section.dataset.video
        const videoUrlMobile = section.dataset.videoMobile
        const gradient = section.dataset.gradient
        const poster = section.dataset.poster

        if (!videoUrl) continue

        if (gradient) {
            section.style.setProperty('--video-gradient', gradient)
        }

        const container = section.querySelector(':scope > .container')
        if (!container) continue

        section.dataset.videoInitialized = ''

        const col = document.createElement('div')
        col.className = 'col'

        const content = document.createElement('div')
        content.className = 'video-source__content'
        while (container.firstChild) {
            content.appendChild(container.firstChild)
        }

        const source = document.createElement('source')
        source.type = 'video/mp4'

        const video = document.createElement('video')
        video.className = 'video-source__video'
        video.muted = true
        video.loop = true
        video.playsInline = true
        video.setAttribute('aria-hidden', 'true')
        video.setAttribute('tabindex', '-1')
        if (poster) {
            video.poster = poster
        }
        if (!prefersReducedMotion) {
            video.autoplay = true
        }
        video.addEventListener('error', () => {
            video.style.display = 'none'
            if (poster) {
                const img = document.createElement('img')
                img.className = 'video-source__video'
                img.src = poster
                img.alt = ''
                img.setAttribute('aria-hidden', 'true')
                col.insertBefore(img, video)
            }
        })
        video.appendChild(source)
        col.appendChild(video)
        col.appendChild(content)
        container.appendChild(col)

        let currentUrl = null
        let resizeTimeout = null

        function updateVideoSource() {
            const isMobile = window.innerWidth < MOBILE_BREAKPOINT
            const url = (isMobile && videoUrlMobile) ? videoUrlMobile : videoUrl

            if (url === currentUrl) return
            currentUrl = url
            source.src = url
            video.load()
            if (!prefersReducedMotion) {
                video.play()
            }
        }

        function onResize() {
            clearTimeout(resizeTimeout)
            resizeTimeout = setTimeout(updateVideoSource, 150)
        }

        updateVideoSource()
        window.addEventListener('resize', onResize)
    }
}
